export default {
  colorPrimary: '#2C5DF6',
  // colorTextPlaceholder: '#878C95',
  // colorText: '#333333',
  // colorBorder: '#EBEBEB',
  // colorTextSecondary: '#999999',
  // colorIcon: '#D2D3D6',
  // colorIconHover: '#B4B5B8',
  // borderRadius: 8,
  // controlHeight: 36,
  // colorBgContainerDisabled: '#FBFBFD',
};
